import { brand } from "../lib/brand";
import { cx } from "../ui/cx";
import styles from "./Brand.module.css";

export { brand, pageTitle } from "../lib/brand";

export function LogoMark({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={cx(styles.mark, className)}
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="32" height="32" rx="7" className={styles.markBg} />
      <path
        d="M20.6 10.4a8 8 0 1 0 0 11.2"
        className={styles.markStroke}
        strokeWidth="3"
        fill="none"
        strokeLinecap="round"
      />
      <path d="M16 16l5.2-5.2" className={styles.markStroke} strokeWidth="3" strokeLinecap="round" />
      <circle cx="16" cy="16" r="2.2" className={styles.markDot} />
    </svg>
  );
}

export function Logo({ size = 32, className }: { size?: number; className?: string }) {
  return (
    <span className={cx(styles.logo, className)} style={{ fontSize: size * 0.82 }}>
      <LogoMark size={size} />
      <span className={styles.word}>{brand.productName.toLowerCase()}</span>
    </span>
  );
}
